// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2XOcw","resendInfoText":"OnGoingPaymentBox_resendInfoText__1uWF2"};